import { ThemeColorVariable as r } from "../../theme/theme-types.js";
function n(o) {
  switch (o) {
    case "success":
      return {
        borderColor: r.Success,
        boxShadow: `0 0 0 4px ${r.SuccessContainer}`,
        _hover: {
          borderColor: r.Success
        }
      };
    case "warning":
      return {
        borderColor: r.Warning,
        boxShadow: `0 0 0 4px ${r.WarningContainer}`,
        _hover: {
          borderColor: r.Warning
        }
      };
    default:
      return;
  }
}
export {
  n as getVisualStateStyle
};
